export default function progressBar(Store, $timeout) {

  const progress = new Store();
  let timers = {};
  const timeout = 10000;

  return {
    add: function (item) {
      progress.add(item);
      timers[item] = $timeout(function () {
        progress.remove(item);
        console.error(item, "timed out");
        //@todo alert the user?
      }, timeout);
    },
    remove: function (item) {
      progress.remove(item);
      $timeout.cancel(timers[item]);
    },
    items: progress.items
  }
}
